import { render } from "./Setting.vue?vue&type=template&id=82d0bfa0"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=82d0bfa0&lang=scss"

import exportComponent from "/home/runner/work/polissonos-web/polissonos-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__